<!-- バックヤード > パスワードを忘れた方 -->
<template>
  <v-container
    fluid
    fill-height
  >
    <v-card
      outlined
      class="mx-auto"
      style="width: 40rem;"
    >
      <v-card-title
        class="justify-center"
      >
        <h3 class="text-center">
          パスワードの再設定が完了しました。
        </h3>
      </v-card-title>
      <v-card-text>
        <p class="text-center">
          再設定したパスワードでログインしてください
        </p>
        <div class="text-center">
          <v-btn
            v-if="enableLoginButton"
            @click="backButtonClickEvent"
          >
            ログイン画面に戻る
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import {mapActions} from 'vuex'
  export default {
    name: 'ForgetCompleted',
    components: {
    },
    mixins: [
    ],
    data () {
      return {
        enableLoginButton: true
      }
    },
    computed: {
    },
    created () {
      if ('sp' in this.$route.query) {
      this.enableLoginButton = false
    }
    },
    methods: {
      backButtonClickEvent () {
        this.$router.push({name: 'DriverSessions'})
      }
      
    },
  }
</script>

<style scoped lang="scss">
</style>
